module.exports = __webpack_public_path__ + "static/img/Pismennost.5ed3617.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Pismennost.jpg
// module id = tyep
// module chunks = 1